module.exports = __webpack_public_path__ + "static/img/product3-7.19703c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3-7.jpg
// module id = 25qz
// module chunks = 0